import { clearError, setError } from '../../components/ErrorBoundary'
import { hideLoader, showLoader } from '../../components/LoaderOverlay'
import { setXlsxValidationErrors, XlsxValidationErrors } from '../../components/XlsxValidationAlert'
import globalStore from '../../store'

import { IBackendErrorData } from './types'

export const showLoaderAction = () => {
  globalStore.dispatch(showLoader())
}

export const hideLoaderAction = () => {
  globalStore.dispatch(hideLoader())
}

export const setErrorAction = (errorData: IBackendErrorData) => {
  globalStore.dispatch(setError(errorData))
}

export const clearErrorAction = () => {
  globalStore.dispatch(clearError())
}

export const setXlsxValidationErrorsAction = (errors: XlsxValidationErrors) => {
  globalStore.dispatch(setXlsxValidationErrors(errors))
}
